export const DASHBOARD = '/';
export const LOGIN = '/login';
export const SIGN_UP = '/sign-up';
export const PROFILE = '/p/:username';
export const MOVIE_PAGE = '/Movie/:id/:title';
export const TVSHOW_PAGE = '/TV/:id/:title';
export const BOOK_PAGE = '/Book/:id/:title';
export const GAME_PAGE = '/Game/:id/:title';
export const LIST_PAGE = '/list/:username/:type/:title';
export const NOT_FOUND = '/not-found';
